import { combineReducers } from 'redux'
import {
  DEBUG_KEY,
  COMPONENT_INITIAL_STATE_KEY,
  PUBLIC_RUNTIME_CONFIG_KEY,
  SHOP_CONFIG_KEY,
  CART_KEY
} from 'shared/store/helper/consts'
import debug from 'shared/store/ducks/debug'
import userSession from 'shared/store/ducks/userSession'
import events from 'shared/store/ducks/events'
import componentInitialState from 'shared/store/ducks/componentInitialState'
import publicRuntimeConfig from 'shared/store/ducks/publicRuntimeConfig'
import shopConfig from 'shared/store/ducks/shopConfig'
import cart from 'shared/store/ducks/cart/cartReducer'

const keyed = {
  // add other reducers (can override the default ones)
  [DEBUG_KEY]: debug,
  userSession,
  [COMPONENT_INITIAL_STATE_KEY]: componentInitialState,
  [PUBLIC_RUNTIME_CONFIG_KEY]: publicRuntimeConfig,
  [SHOP_CONFIG_KEY]: shopConfig,
  events,
  [CART_KEY]: cart
}

const reducer = combineReducers(keyed)

export default reducer

export { keyed } // TODO: Remove once checkout is dropped
